export function checkColumnCompletion(
 exerciseIndex: number,
 exercisesDataState: any[]
) {
 const exercise = exercisesDataState[exerciseIndex];

 if (!exercise) return false;

 // Get all exercise objects and basic fields
 const exerciseObjects: any[] = [];
 const basicFields: any[] = [];

 Object.entries(exercise).forEach(([key, value]) => {
  if (typeof value === 'object' && value !== null && 'value' in value) {
   exerciseObjects.push(value);
  } else if (
   typeof value !== 'object' &&
   ![
    'name',
    'time',
    'patientId',
    'visitId',
    '_id',
    'number',
    'isCompleted',
    'isAssigned',
   ].includes(key)
  ) {
   basicFields.push(value);
  }
 });

 // Check blood pressure fields
 const bloodPressureFields = [
  exercise.bloodPressureBefore,
  exercise.bloodPressureAfter,
 ].filter(Boolean);
 const validBloodPressure =
  bloodPressureFields.length === 2 &&
  bloodPressureFields.every((bp: string) => {
   return (
    bp &&
    typeof bp === 'string' &&
    bp.includes('/') &&
    bp.split('/').filter(Boolean).length === 2
   );
  });

 // Check pulse fields
 const pulseFields = [exercise.pulseBefore, exercise.pulseAfter].filter(
  Boolean
 );
 const validPulse =
  pulseFields.length === 2 && pulseFields.every((p: any) => p !== '');

 // Check angle field
 const validAngle = exercise.angle && exercise.angle !== '';

 // Only check exercises that have been started (have a value)
 const startedExercises = exerciseObjects.filter(
  (ex) => ex.value && ex.value !== ''
 );
 const allStartedExercisesRated =
  startedExercises.length > 0 &&
  startedExercises.every((ex: any) => ex.like || ex.dislike || ex.disabled);

 // A column is complete if:
 // 1. Blood pressure is filled correctly
 // 2. Pulse is filled correctly
 // 3. Angle is filled
 // 4. At least one exercise is started and all started exercises are rated
 const isComplete =
  validBloodPressure && validPulse && validAngle && allStartedExercisesRated;

 return isComplete;
}
